// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1206":"c953c4d36ca56de4","2750":"056e6ea0b73a0144","4067":"07244ce131dc27b9","8862":"9debb0383bfcca5d"}[chunkId] + ".css";
};